(() => {
  'use strict';
  const roots = new WeakSet();
  function init() {
    const header = document.querySelector('.header');
    if (header && !roots.has(header)) {
      roots.add(header);
      const dialog = document.getElementById('STBMobileMenu');
      const opener = header.querySelector('[data-stb-menu-open]');
      const close = () => { if (dialog?.open) dialog.close(); };
      opener?.addEventListener('click', () => { dialog.showModal(); opener.setAttribute('aria-expanded','true'); });
      dialog?.querySelector('[data-stb-menu-close]')?.addEventListener('click', close);
      dialog?.addEventListener('close', () => {opener?.setAttribute('aria-expanded','false'); opener?.focus();});
      dialog?.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      });
      const toggle = header.querySelector('[data-search-toggle]');
      const panel = header.querySelector('#STBHeaderSearch');
      const closeSearch = () => {if (!panel) return; panel.hidden=true;panel.classList.remove('search-header--open');toggle?.setAttribute('aria-expanded','false');toggle?.focus();};
      toggle?.addEventListener('click', () => {panel.hidden=false;panel.classList.add('search-header--open');toggle.setAttribute('aria-expanded','true');panel.querySelector('input').focus();});
      panel?.querySelector('[data-stb-search-close]')?.addEventListener('click',closeSearch);
      panel?.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();closeSearch();}});
    }
    document.querySelectorAll('[data-stb-empty-product=true]').forEach(link => {
      if (link.dataset.emptyBound) return;
      link.dataset.emptyBound='true';
      link.addEventListener('click',event=>event.preventDefault());
    });
    document.querySelectorAll('.stbm-faq-question').forEach(button=>{
      if (!button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded',String(button.closest('.stbm-faq-item')?.classList.contains('open')||false));
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load',init);
})();
